/* eslint-disable */
import React, { useState } from 'react';
import compose from 'lodash/fp/compose';
import { Link, NavLink, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { withTranslation, withAccount, withUserPreferences } from '../hoc';
import logo from '../../static/demo/brand/Admincatlogo1.png';
import logoInverted from '../../static/demo/brand/AdminCatinverted.png';
import BaseDropdown from '../common/BaseDropdown';
import { useScrollPosition } from '../../hooks/useScrollPosition';
import {
  StyledHeader,
  Logo,
  Avatar,
  UserName,
  Navbar,
  NavMenu,
  Dropdown,
  AvatarSection,
} from './styled';
import { useTranslation } from 'react-i18next';
import axios from '../../axios';
import DarkModeToggle from 'components/common/DarkModeToggle';
import SessionCountdown from 'components/SessionTimeout/SessionCountdown';
import { useDarkMode } from 'context/DarkModeContext';

const DropdownMenu = BaseDropdown.DropdownMenu;

// Breakpoints
const mobileBreakpoint = '800px';

const publicNavLinks = [
  {
    path: '/',
    name: 'Home',
    exact: true,
  },
  {
    path: '/service',
    name: 'Service',
  },
  {
    path: '/features',
    name: 'Features',
  },
  {
    path: '/pricing',
    name: 'Pricing',
  },
  {
    path: '/faq',
    name: 'FAQ',
  },
];

const actionRoutes = [
  {
    path: '/login',
    name: 'Login',
    authRequired: false,
  },
  {
    path: '/register',
    name: 'Sign up',
    authRequired: false,
    className: 'blue-link',
  },
];

const dropdownMenuLinks = [
  {
    path: '/dashboard/space-admin',
    name: 'Space Member',
    icon: 'user outline',
    isSpaceAdmin: true,
  },
  {
    path: '/dashboard/settings',
    name: 'Settings',
    icon: 'setting',
  },

  {
    path: '/dashboard/contact-us',
    name: 'Contact Us',
    icon: 'comment outline',
  },
];


const LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  height: auto;
  margin-left: 0;
  text-decoration: none;

  @media (max-width: ${mobileBreakpoint}) {
    margin-left: 0;
  }
`;

const StyledDropdownIcon = styled(Icon)`
  &&& {
    color: var(--admincat-color-grey-3) !important;;
  }
`;

const DropdownMenuLink = styled(Link)`
  display: flex;
  color: var(--admincat-color-grey-3);
`;

const SelectItem = styled.select`
  /* margin-left: 55em; */
  padding: 10px 18px;
  background: #f8f9fc;
  border: solid 1px #d7e3f7;
  font-size: 14px;
  height: 42px;
  min-width: 82px;
  border-radius: 8px;
  color: #445273;
  transition: border 0.2s ease, box-shadow 0.2s ease;

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    padding: 16px 22px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    background: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    height: auto;
    min-height: 52px;
    line-height: 1.35;
    box-sizing: border-box;

    &:hover {
      background: #f8f9fa;
    }
  }
`;

const HeaderNavigation = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-left: clamp(42px, 8vw, 120px);

  @media (max-width: 1024px) {
    margin-left: 32px;
  }

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    margin-left: 0;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 16px;
  }
`;

const PageNavList = styled.ul`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 34px;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin: 0;
    padding: 0;
  }

  @media (max-width: 1080px) {
    gap: 22px;
  }

  @media (max-width: ${mobileBreakpoint}) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const HeaderPageLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover,
  &.active {
    color: var(--blue, #5484c3);
    text-decoration: none;
  }

  &.active {
    font-weight: 600;
  }

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    min-height: 52px;
    padding: 0 18px;
    border-bottom: 1px solid rgba(76, 129, 190, 0.14);
    color: #24385d;
    font-size: 16px;
  }
`;

const HeaderActions = styled(Navbar)`
  flex: 0 0 auto;
  gap: 20px;

  &&& a {
    background: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    color: #40516f;
    font-size: 15px;
    font-weight: 600;
    height: auto;
    min-width: 0;
    padding: 0;
  }

  &&& a:hover {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
    color: #2f6fb9;
    transform: none;
  }

  &&& a.blue-link {
    background: #5b89c8;
    border: 0;
    border-radius: 8px;
    box-shadow: 0 10px 18px rgba(73, 124, 190, 0.32);
    color: #ffffff;
    font-size: 15px;
    font-weight: 800;
    height: 44px;
    min-width: 104px;
    padding: 0 24px;
  }

  &&& a.blue-link:hover {
    background: #4d7fbe;
    box-shadow: 0 12px 20px rgba(73, 124, 190, 0.38);
    color: #ffffff;
    transform: translateY(-1px);
  }

  @media (max-width: ${mobileBreakpoint}) {
    width: 100%;
    gap: 12px;

    &&& a,
    &&& a.blue-link {
      border-radius: 14px;
      font-size: 16px;
      height: 52px;
      justify-content: center;
      padding: 0 22px;
      width: 100%;
    }

    &&& a {
      background: #ffffff;
      border: 1px solid rgba(76, 129, 190, 0.18);
      color: #24385d;
    }

    &&& a:hover {
      background: #f8fbff;
      transform: translateX(4px);
    }
  }
`;

const MobileMenuToggle = styled.button`
  margin-left: auto;
  padding: 10px;
  background: transparent;
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: rgba(76, 129, 190, 0.12);
  }

  &:active {
    transform: scale(0.96);
  }
`;

class DropdownSection extends BaseDropdown {
  usernamePref = JSON.parse(localStorage.getItem('username'));
  render() {
    const {
      tr,
      account: {
        user: { username, isAuth, space_admin },
      },
      logout,
      className = '',
      showHamburger,
    } = this.props;

    return (
      <Dropdown className={className}>
        {isAuth && <SessionCountdown tr={tr} />}
        {showHamburger ? (
          <MobileMenuToggle
            type="button"
            ref={(e) => (this.dropdownTriggerRef = e)}
            onClick={this.changeDropdownState}
          >
            <StyledIcon name="bars" />
          </MobileMenuToggle>
        ) : (
          <AvatarSection
            ref={(e) => (this.dropdownTriggerRef = e)}
            onClick={this.changeDropdownState}
            isAuth={isAuth}
          >
            <Avatar />
            <UserName>{username}</UserName>
          </AvatarSection>
        )}
        <DropdownMenu ref={(e) => (this.dropdownRef = e)}>
          {dropdownMenuLinks
            .filter(({ isSpaceAdmin }) => {
              if (isSpaceAdmin && !space_admin) return false;
              return true;
            })
            .map(({ icon, name, path }) => (
              <DropdownMenu.Item key={name}>
                <DropdownMenuLink to={path}>
                  <StyledDropdownIcon name={icon} />
                  <span>{tr(name)}</span>
                </DropdownMenuLink>
              </DropdownMenu.Item>
            ))}
          <DropdownMenu.Item onClick={logout} style={{ color: 'var(--admincat-color-grey-3)' }}>
            <StyledDropdownIcon name="sign-out" />
            <span>{tr('Sign out')}</span>
          </DropdownMenu.Item>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const NavbarSection = (props) => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState("");

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  React.useEffect(() => {
    let selected = localStorage.getItem('i18nextLng');
    selected = selected === 'en' ? 'eng' : selected === 'de' ? 'deu' : '';
    setLanguage(selected);
  }, [language]);

  const handleOnChange = (e) => {
    if (e.target.value === 'deu') {
      changeLanguage('deu');
      setLanguage('deu');
      localStorage.setItem('i18nextLng', 'de');
      axios.defaults.headers.common['Accept-Language'] = 'de';
    } else if (e.target.value === 'eng') {
      changeLanguage('eng');
      setLanguage('eng');
      localStorage.setItem('i18nextLng', 'en');
      axios.defaults.headers.common['Accept-Language'] = 'en';
    }
    if (props.onLinkClick) {
      props.onLinkClick();
    }
  };

  const {
    tr,
    account: {
      user: { isAuth = false },
    },
    className = '',
  } = props;

  const DetectLanguage = isAuth ? tr : t;

  if (!isAuth) {
    return (
      <HeaderNavigation className={className}>
        <PageNavList aria-label={DetectLanguage('Main navigation')}>
          {publicNavLinks.map(({ path, name, exact = false }) => (
            <li key={path}>
              <HeaderPageLink
                to={path}
                end={exact}
                onClick={() => { if (props.onLinkClick) props.onLinkClick(); }}
              >
                {DetectLanguage(name)}
              </HeaderPageLink>
            </li>
          ))}
        </PageNavList>

        <HeaderActions className="NavBar">
          <Navbar.Item>
            <SelectItem
              onChange={handleOnChange}
              value={language || ""}
              style={{ width: '100%' }}
            >
              <option value="eng">ENG</option>
              <option value="deu">DEU</option>
            </SelectItem>
          </Navbar.Item>

          {actionRoutes.map(({ path, name, exact = false, className }, index) => (
            <Navbar.Item key={index}>
              <NavLink
                to={path}
                end={exact}
                className={className}
                style={{ width: '100%' }}
                onClick={() => { if (props.onLinkClick) props.onLinkClick(); }}
              >
                {DetectLanguage(name)}
              </NavLink>
            </Navbar.Item>
          ))}
        </HeaderActions>
      </HeaderNavigation>
    );
  }

  return (
    <Navbar className={`NavBar ${className}`}>
      {actionRoutes
        .filter(({ authRequired }) => {
          return authRequired === undefined || authRequired === isAuth;
        })
        .map(({ path, name, exact = false, className }, index) => (
          <Navbar.Item key={index}>
            <NavLink
              to={path}
              end={exact}
              className={className}
              style={{ width: '100%' }}
              onClick={() => { if (props.onLinkClick) props.onLinkClick(); }}
            >
              {DetectLanguage(name)}
            </NavLink>
          </Navbar.Item>
        ))}
    </Navbar>
  );
};

const StyledMobileHeader = styled(StyledHeader)`
  display: none;
  @media (max-width: ${mobileBreakpoint}) {
    display: flex;
    align-items: center;
    padding: 0 12px;
    position: relative;
    height: 64px;
  }
`;


const MobileNavMenu = styled(NavMenu)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms ease-in-out;

  /* reduce centered-logo width on smaller devices to avoid overlap */
  @media (max-width: 800px) {
    max-width: 140px;
  }

  @media (max-width: 480px) {
    max-width: 120px;
  }

  @media (max-width: 375px) {
    max-width: 100px;
  }

  @media (max-width: 320px) {
    max-width: 84px;
  }
`;

// const MobileNavMenu = styled(NavMenu)`
//   position: absolute;
//   left: 50%;
//   transform: translateX(-50%);
//   z-index: 1;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: all 300ms ease-in-out;
  
//   @media (max-width: 800px) {
//     max-width: 160px;
//   }
  
//   @media (max-width: 480px) {
//     max-width: 140px;
//   }
  
//   @media (max-width: 375px) {
//     max-width: 120px;
//   }
  
//   @media (max-width: 320px) {
//     max-width: 100px;
//   }
// `;


const MobileRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 1002;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);

  @media (max-width: 480px) {
    gap: 8px;
    right: 10px;
  }

  @media (max-width: 375px) {
    gap: 8px;
    right: 3px;
  }

  @media (max-width: 320px) {
    gap: 8px;
    right: 4px;
  }
`;




const StyledIcon = styled(Icon)`
  && {
    font-size: 2rem;
    margin: 0;
    color: #637599;
    
    @media (max-width: 480px) {
      font-size: 1.75rem;
    }
    
    @media (max-width: 375px) {
      font-size: 1.5rem;
    }
  }
`;

const MobileNavbarSection = styled(NavbarSection)`
  flex-direction: column;
  width: 100%;
  margin: 0;
  height: 100%;
  overflow: visible;
  position: relative;
  transition: all 300ms ease-in-out;
  justify-content: flex-start;
  gap: 16px;
  align-items: stretch;

  li {
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

const MobileNavMenuWrapper = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  height: 100vh;
  width: 85vw;
  max-width: 420px;
  background: linear-gradient(180deg, #f5f8ff 0%, #ffffff 55%);
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  box-shadow: -8px 0 24px rgba(33, 60, 131, 0.18);
  border-left: 1px solid rgba(123, 153, 207, 0.2);
  z-index: 12000;
  padding: 32px 24px 48px;
  display: flex;
  justify-content: flex-start;
  transition: all 280ms ease;
  flex-direction: column;
  align-items: stretch;
  gap: 18px;
  overflow-y: auto;
`;

class MobileHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubMenu: false,
    };
  }

  toggleSubMenu = () => {
    this.setState((prevState) => ({
      showSubMenu: !prevState.showSubMenu,
    }));
  };

  closeSubMenu = () => {
    this.setState({ showSubMenu: false });
  };

  render() {
    const {
      account: {
        user: { isAuth },
      },
    } = this.props;

    return (
      <StyledMobileHeader>
        <MobileNavMenu>
          {Boolean(isAuth === true) ? (
            <Logo src={logo} />
          ) : (
            <LogoWrapper to="/">
              <Logo $public src={logo} />
            </LogoWrapper>
          )}
        </MobileNavMenu>
        <MobileRightSection>
          {Boolean(isAuth === true) ? (
            <>
              <DarkModeToggle />
              <DropdownSection {...this.props} showHamburger />
            </>
          ) : (
            <MobileMenuToggle onClick={this.toggleSubMenu} type="button">
              <StyledIcon name="bars" />
            </MobileMenuToggle>
          )}
        </MobileRightSection>
        {this.state.showSubMenu && (
          <MobileNavMenuWrapper ref={(e) => (this.dropdownRef = e)}>
            <div>
              <MobileNavbarSection {...this.props} onLinkClick={this.closeSubMenu} />
            </div>
          </MobileNavMenuWrapper>
        )}
      </StyledMobileHeader>
    );
  }
}

const DesktopHeader = styled(StyledHeader)`
  height: 72px;

  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
`;

const DesktopHeaderColormode = styled(StyledHeader)`
  background: var(--admincat-color-grey-1);
  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
`;

const StyledDropdownSection = styled(DropdownSection)`
  margin-right: 0;
  position: relative;
  z-index: 2;

  ${DropdownMenu} {
    right: 0;
    min-width: 170px;
    max-width: calc(100vw - 24px);
    z-index: 2;
  }

  ${DropdownMenu.Item} {
    align-items: center;
    letter-spacing: 0;
    white-space: nowrap;
  }

  ${DropdownMenu} a,
  ${DropdownMenu} span {
    white-space: nowrap;
  }
`;

const HeaderWrapper = styled.div`
  background: transparent;
  padding: 0;
  position: relative;
  z-index: 700;
  overflow: visible;
  ${({ fixHeader }) =>
    fixHeader &&
    css`
      position: sticky;
      top: 0;
    `}
`;

const Header = (props) => {
  const { position } = useScrollPosition();
  const {
    account: {
      user: { isAuth },
    },
  } = props;

  const { isDarkMode } = useDarkMode();
  const location = useLocation();

  const src = isDarkMode ? logoInverted : logo;

  // Render null if the route is /admin because of the admin ui design
  if (location.pathname === '/admin') {
    return null;
  }

  return (
    <HeaderWrapper fixHeader={position > 0} isAuth>
      {Boolean(isAuth === true) ? (
        <>
          <DesktopHeaderColormode>
            <NavMenu>
              {Boolean(isAuth === true) ? (
                <LogoWrapper to="/dashboard">
                  <Logo src={src} />
                </LogoWrapper>
              ) : (
                <LogoWrapper to="/">
                  <Logo $public src={logo} />
                </LogoWrapper>
              )}

              <NavbarSection {...props} />
            </NavMenu>

            {Boolean(isAuth === true) && <DarkModeToggle />}

            {Boolean(isAuth === true) && <StyledDropdownSection {...props} />}
          </DesktopHeaderColormode>
          <MobileHeader {...props} />
        </>
      ) : (
        <>
          <DesktopHeader>
            <NavMenu>
              {Boolean(isAuth === true) ? (
                <LogoWrapper to="/dashboard">
                  <Logo src={src} />
                </LogoWrapper>
              ) : (
                <LogoWrapper to="/">
                  <Logo $public src={logo} />
                </LogoWrapper>
              )}

              <NavbarSection {...props} />
            </NavMenu>

            {Boolean(isAuth === true) && <DarkModeToggle />}

            {Boolean(isAuth === true) && <StyledDropdownSection {...props} />}
          </DesktopHeader>
          <MobileHeader {...props} />
        </>
      )}
    </HeaderWrapper>
  );
};

export default compose(
  withAccount,
  withTranslation,
  withUserPreferences,
)(Header);
